// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  prefix:'dev_',
  firebaseConfig : {
    apiKey: "AIzaSyAK76g5_teGAptyRgILgxLo5mfep7UNUPc",
    authDomain: "ruecart-ng.firebaseapp.com",
    databaseURL: "https://ruecart-ng-default-rtdb.firebaseio.com",
    projectId: "ruecart-ng",
    storageBucket: "ruecart-ng.firebasestorage.app",
    messagingSenderId: "332723148698",
    appId: "1:332723148698:web:53818939f5b84c72720c23",
    measurementId: "G-S6FMD62WJY"
  },
  mapKey:  "AIzaSyBBEynhMRGDVyWfyOPZ6FBMWcJwxHM3zGI",//"AIzaSyBEW60pBY3MX5t_DmXBo3NjEX5geXrsBkk",
  vapidKey:"BOTOwGUE0OsiDaKTqYAposv6FFHLz8SVfwifB0RWiSSYzYb6mChQzntziRNJj0aI8ilxUo2P3aR3NfAUClNmGfQ",
  api:'https://ruecart-ng-vendor-ms-dev-332723148698.us-central1.run.app/',
  storeLink:"https://store-ng-dev.ruecart.com/store/",
  collections:{
    VENDOR: 'vendor',  // Collection for vendor
    PRODUCTS: 'products',  // Collection for product
    SERVICES: 'services',  // Collection for services
    CLIENT:'client',      //Collection for client user
    VENDOR_ORDER:'vendor_order',     //Collection for vendor order
    VENDOR_SERVICE_ORDER:'vendor_service_order',
    VENDOR_USERS:'vendor_user',
  },
  endpoints:{
    MESSAGING: 'order/messaging',   //endpoint for messaging
    SERVICES_MESSAGING: 'service/messaging',   //endpoint for services messaging
    UPDATES: 'order/updates',        // endpoint for updates/vendor actions on orders
    SERVICES_UPDATES: 'service/updates', // endpoint for updates/vendor actions on services orders
    UPDATE_TOKEN: 'order/messaging/register-token',
    PRODUCT: 'product',
    PRODUCT_DELETE: 'product/delete',
    SERVICE: 'service',
    CHECK_EMAIL: 'vendor/check-email',
    VENDOR: 'create_baines_vendor',//'vendor', Changed for BainesCredit Bank
    QUERY_BANK_CUSTOMER: 'create_baines_vendor/existing-bank-customer', //Query Baines Existing bank customer
    INITIATE_BVN: 'create_baines_vendor/initiate-bvn-validation',
    BVN_VALIDATION: 'create_baines_vendor/bvn-otp-validation',
    GLOBAL_AVAILABILITY:'service/availability',
    SEND_FEEDBACK:'feedback',
    CREATE_VENDOR_USER:'user/create-vendor-user',
    CHANGE_VENDOR_USER_STATUS:'user/update-status', //To activate or deactivate user
    CHANGE_VENDOR_ADMIN_STATUS:'user/update-admin-status', //To activate or deactivate user,
    HELP:'help',
    REPORTS:'report'
   
  },
  version:'1.1.0'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
